import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Components
import StaticBoard from "../components/StaticBoard";
import ScoreFunction from "../components/ScoreFunction"
import instructionSheets from "../data/instructionSheets.js";
import VboardStates from "../data/VboardStates.js";
import Button from "../components/Button";

class Feedback extends Component {


  render() {
	
	const userFinalStateBoard = this.props.userSteps[this.props.lastStepIdx]["board_state"]
	const taskId = instructionSheets[this.props.taskUserId]["taskId"]
	const numberedBoard = instructionSheets[this.props.taskUserId]["numberedBoard"]
	return (
	<GridLayout>
      <InstructionContainer>
          <h2>Score</h2>
		  <P>
			 Your Matching Score is: &nbsp; 
			<b> 
			{(this.props.lastStepIdx===0)?  "No Score" : ScoreFunction(userFinalStateBoard,taskId)}
			
			 </b> 
			<br/>This score measures how well your image matches to the target image.
			<br/> You may visually compare your image on the left to the target image on the right. 
			<br/> <br/> 
			{/* don't show this note on practice mode 
			<div style={this.props.practiceMode? {display:"none"} : null} >
				<b> Note: </b>
				Your Mathching Score will not affect directly on your HIT acceptance. 
				We certainly take in consideration that low Matching Score could be induced 
				from inaccuracies in the drawing procedure and not necessarily because of low performance. 
			</div>
			*/}
			<br/> Please close this window.
			</P>
		  
		  <br/>
		  
		</InstructionContainer>      
		 
       	<UserBoardContainer>
		<h2> Your Image </h2>
		<StaticBoard
            // if there is no user action return an empty board otherwise return user final result.
			// Though it won't happen in production it useful for dev stage. 
			boardState = {
				(this.props.lastStepIdx===0)?  Array(181).fill (0) : userFinalStateBoard
			}
			NumberedBoard = {numberedBoard}		 
          />
		</UserBoardContainer> 
	   
	   <OriginalBoardContainer>
		<h2> Target Image </h2>
			<StaticBoard
				boardState = {VboardStates[taskId]} 
				NumberedBoard = {numberedBoard}	
			  />
		</OriginalBoardContainer>
		
		{/* <StyledButton onClick= {() => {window.open("about:blank", "_self").close()}}>
		Close
		</StyledButton>
		*/}
		
				
	</GridLayout>	
      
    );
  }
}

export default Feedback;

const GridLayout = styled.div`
display: grid ;
grid-template-columns: 50% 50%;
grid-template-areas:
    "instruction instruction"
	"user original"
	"button button";
`;


const InstructionContainer = styled.div`
background: lightblue;
margin: 3em;
width: 90vw;
grid-area: instruction;

`;
 
const P = styled.p`
text-align: left;
font-size: large;
margin: 1em;
`;

const ElementContainer = styled.div`
  margin: 1em 2em; // that makes some space bewtween the containers so they are not tight to each other
 background-color: white;
  width: 45vw;
  max-height: 75vh;
  
`;


const OriginalBoardContainer = styled(ElementContainer)`
display: inline-block;
align-items: center;
grid-area: original;



`;

const UserBoardContainer = styled(ElementContainer)`
display: inline-block;
align-items: center;
grid-area: user;


`;

const StyledButton = styled(Button)`
  width: 10%;
  margin-left: 45% ;
  grid-area: button;
  background: orange;
  
`;
